export default "__VITE_ASSET__61d76c1c__"